import { TileRepository } from "@infrastructure/repositories/tile-repository";

export class TileGetByIdUseCase {
  constructor(private readonly tileRepository: TileRepository) {}

  public async execute(id: string) {
    return await this.tileRepository.getById(id);
  }
}
